<template>
  <div v-if="!noContent">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="agora-na-radio" v-if="currentItem.nameLocutor">
          <img v-if="currentItem.imageLocutor || currentItem.imageLocutor != ''" :src="currentItem.imageLocutor"/>
          <img v-if="!currentItem.imageLocutor" src="static/images/semlocutor2.jpg"/>
          <span>
            {{ currentItem.initHour }} - {{ currentItem.finishHour }}
          </span>
          <span>
            <router-link :to="getUrlProgram(currentItem.idProgram, currentItem.nameProgram)"><strong>
              {{ currentItem.nameProgram }}</strong>
            </router-link>
            <router-link :to="getUrlLocutor(currentItem.idLocutor, currentItem.nameLocutor)">
              - {{ currentItem.nameLocutor }}
            </router-link>
          </span>
        </div>
        <div v-if="!currentItem.nameLocutor">
          Sem programação no momento
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import {slugify} from '../../helpers/slugify';
  import {mapActions, mapGetters} from 'vuex'

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Agora na rádio',
        showContent: false,
        noContent: false,
        now: new Date(),
        currentItem: {},
        items: []
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      self.getAgoraNaRadio();
    },
    mounted() {
      let self = this;
      setInterval(function () {
        self.getAgoraNaRadio();
      }, 30000);
    },
    methods: {
      ...mapActions(['setAgoraRadio']),
      getUrlLocutor(id, string) {
        return '/locutor/' + id + '/' + slugify(string);
      },
      getUrlProgram(id, string) {
        return '/programa/' + id + '/' + slugify(string);
      },
      getAgoraNaRadio() {
        let self = this;
        get('content/' + this.bloco.id).then(function (response) {
          self.showContent = true;
          self.setAgoraRadio(response.data.result.data)
          self.items = response.data.result.data;
          if (self.items[0]) {
            self.currentItem = self.items[0];
          }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/NowInRadioList.vue